module.exports = __webpack_public_path__ + "static/img/6.c680655.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/eng/6.png
// module id = c39O
// module chunks = 0